import MerchantEvaluationSchemeConfigApi from '@/api/merchant-evaluation-scheme-config'

/**
 * 评审系统 - 评审方案管理
 */

const state = { }

const mutations = { }

const actions = {
  async list ({ commit }, params) {
    const result = await MerchantEvaluationSchemeConfigApi.list(params)
    return result
  },
  async getById ({ commit }, id) {
    const result = await MerchantEvaluationSchemeConfigApi.getById(id)
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.insert(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.update(data)
    return result
  },
  async remove ({ commit }, id) {
    const result = await MerchantEvaluationSchemeConfigApi.remove(id)
    return result
  },
  async listItems ({ commit }, params) {
    const result = await MerchantEvaluationSchemeConfigApi.listItems(params)
    return result
  },
  async addItem ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.addItem(data)
    return result
  },
  async updateItem ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.updateItem(data)
    return result
  },
  async getItem ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.getItem(data)
    return result
  },
  async removeItem ({ commit }, data) {
    const result = await MerchantEvaluationSchemeConfigApi.removeItem(data)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-scheme-config.js